import React from 'react'

import Immutable from 'immutable'
import PropTypes from 'prop-types'

import { getRecipeIngredients } from 'routes/Menu/context/recipeContext'

import { Allergens } from '../Allergens/Allergens'
import { IngredientsList } from '../IngredientsList/IngredientsList'

import css from '../Detail.css'

const DetailAllergenIngredients = ({ allergens, recipe, loading }) => {
  const { size, ingredients } = getRecipeIngredients(recipe)

  if (loading || size === 0) {
    return null
  }

  return (
    <div className={css.sectionPanel} data-testing="recipeDetailsAllergenList">
      <IngredientsList ingredients={ingredients} allergens={allergens} />
      <Allergens allergens={allergens} />
    </div>
  )
}

DetailAllergenIngredients.propTypes = {
  allergens: PropTypes.instanceOf(Immutable.List),
  recipe: PropTypes.instanceOf(Object).isRequired,
  loading: PropTypes.bool.isRequired,
}
DetailAllergenIngredients.defaultProps = {
  allergens: PropTypes.instanceOf(Immutable.List),
}

export { DetailAllergenIngredients }
